<div class="block">
  <h1>Woo Status</h1>
  <div class="account__card">
    @for(metric of metrics; track $index) {
      <div class="border--all border-width--strong border--{{metric.css}} margin-bottom--1x">
        <div role="button" class="section row margin--none {{metric.css}}" (click)="toggle(metric);">
          <div class="col-1">
            <div class="status__badge with--icon {{metric.css}}"></div>
          </div>
          <div class="col-7">
            <h2 class="text--white">{{metric.name}}</h2>
          </div>
          <div class="col-4">
            <h2 class="float-end text--white">{{metric.description}}</h2>
          </div>
        </div>
        @if(expanded[metric.name]) {
          <div class="row margin--none">
            @if(showMetricDetails(metric)) {
              <div class="col-12">
                <pre class="margin-top-bottom--1x border p-2 bg-light">{{metric.details}}</pre>
              </div>
            }
            @if(showPlannerAction(metric)) {
              <div class="col-12">
                <div class="padding--1x">
                  <h3>Vad kan man göra?</h3>
                  <p>{{metric.planner_action}}</p>
                </div>
              </div>
            }
            @if(showAdminAction(metric)) {
              <div class="col-12">
                <div class="padding--1x">
                  @if(!showPlannerAction(metric)) {
                    <h3>Vad kan man göra?</h3>
                  }
                  <p>{{metric.admin_action}}</p>
                </div>
              </div>
            }
            @if(showMetricTask(metric)) {
              <div class="col-12">
                <div class="padding--1x">
                  <h3>Verktyg</h3>
                  <woo-code>{{metric.task}}</woo-code>
                </div>
              </div>
            }
            @if(showCRMUpdateButton(metric)) {
              <div class="padding--1x">
                <button class="button primary" (click)="updateCRMStatus()">Uppdatera CRAM-import status</button>
              </div>
            }
          </div>
        }
      </div>
    }
    @if(metricsUpdated) {
      <p>Uppdaterad <b>{{metricsUpdated}}</b>.</p>  
    }
  </div>
</div>

